@if (!event.isFinished() && babTabs.length) {
    <div class="precreated-tabs">
        <ds-tabs-group size="small" variant="horizontal" scrollable="true" [fullWidthTabs]="false" (activeTabChange)="setSubGroupTabSelected($event)">
            @for (tab of babTabs; track $index) {
                <ds-tab [name]="tab.id.toString()">
                    <ng-container *dsTabHeader>
                        <span [class.selected]="tab.active">
                            {{ tab.title }}
                            @if (tab.count) {
                                <ds-notification-bubble size="medium" [variant]="tab.active ? 'primary' : 'neutral'">
                                    {{ tab.count }}
                                </ds-notification-bubble>
                            }
                        </span>
                    </ng-container>
                </ds-tab>
            }
        </ds-tabs-group>
    </div>
}
<ms-precreated-bab-option
    [event]="event"
    [optionGroup]="activeGroup"
    [showMarketHelp]="showMarketHelp"
    [tabChanged]="tabChanged"
    [fixtureId]="fixtureId"
    [showMoreCounter]="showMoreCounter"
    [optionsLimitOverride]="optionsLimitOverride"
    [buttonSource]="buttonSource"
    [tracking]="tracking"
    [trackingModuleType]="trackingModuleType"
    [betBuilderEpcotEnabled]="betBuilderEpcotEnabled"
    [hideBetBuilderButton]="hideBetBuilderButton"
    [sourceOfPick]="sourceOfPick"
    (showAllRequested)="showAllRequested.next()" />
